import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const AuthorImage = ({ authorURL, alt }) => {
  if (authorURL.includes('https')) {
    return (
      <img src={authorURL} alt={alt} className="author-image rounded-circle" />
    );
  }

  const className = `author-${alt.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div
      className={`author-image rounded-circle ${className}`}
      style={{ width: '50px', height: '50px' }}
    />
  );
};

AuthorImage.propTypes = {
  authorURL: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default AuthorImage;
